import Echo from 'laravel-echo';
import { checkSleepMode } from 'utils/detectWakeMode';
import { app } from '../../app';

export default {
    install(Vue, options) {
        const $echo = new Echo(options);
        $echo.connector.pusher.bind_global((eventName, data) => {
            checkSleepMode(eventName);
        });

        app.config.globalProperties.$echo = $echo;

        Vue.mixin({
            methods: {
                echoChannel() {
                    const echo = this.$options['echo'] || {};
                    let channel = echo.channel;

                    if (typeof channel === 'function') {
                        channel = channel(this);
                    }

                    if (!channel) {
                        return [];
                    }

                    if (channel.startsWith('private:')) {
                        return [channel.replace('private:', ''), 'private'];
                    }

                    if (channel.startsWith('presence:')) {
                        return [channel.replace('presence:', ''), 'join'];
                    }

                    return [channel, 'channel'];
                },

                echoConnect() {
                    const [channel, method] = this.echoChannel();

                    if (channel) {
                        this.echo = this.$echo[method](channel);
                        this.echoEvents();
                    }
                },

                echoDisconnect() {
                    const [channel] = this.echoChannel();
                    this.$echo.leave(channel);
                    this.echo = null;
                },

                echoEvents() {
                    const echo = this.$options['echo'] || {};
                    if (echo.events) {
                        Object.keys(echo.events).forEach((key) => {
                            this.$echo.listen(key, (payload) => {
                                echo.events[key](payload, this);
                            });
                        }, this);
                    }
                },
            },

            mounted() {
                const echo = this.$options['echo'] || {};
                if (echo.delay) {
                    return;
                }

                this.echoConnect();
            },

            beforeUnmount() {
                this.echoDisconnect();
            },
        });
    },
};
